module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "15px",
      "margin-top": "15px"
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, _vm._l((_vm.images), function(path) {
    return _c('img', {
      key: path,
      staticClass: "round white-border shadow",
      staticStyle: {
        "margin-left": "-15px",
        "margin-top": "-15px"
      },
      attrs: {
        "width": _vm.size,
        "height": _vm.size,
        "src": path,
        "alt": ""
      }
    })
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5189337a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/ImageGroup.vue
// module id = 2545
// module chunks = 1